import { render, staticRenderFns } from "./core-routing-setting.vue?vue&type=template&id=2facb8ae&scoped=true"
import script from "./core-routing-setting.vue?vue&type=script&lang=js"
export * from "./core-routing-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facb8ae",
  null
  
)

export default component.exports